import React, { useState, useEffect, useRef, useMemo ,useCallback } from "react";
import scroller1 from "../../assets/Home/scrollers/Scroller1.svg";
import scroller2 from "../../assets/Home/scrollers/Scroller2.svg";
import scroller3 from "../../assets/Home/scrollers/Scroller3.svg";
import scroller4 from "../../assets/Home/scrollers/Scroller4.svg";
import scroller5 from "../../assets/Home/scrollers/Scroller5.svg";

import Banner from "../../assets/Home/Banner.png";
import viewMoreImg from "../../assets/Home/ViewMore.svg";
import viewLessImg from "../../assets/Home/ViewLess.svg";
import Category1 from "../../assets/Home/categories/Category1.png";
import Category2 from "../../assets/Home/categories/Category2.png";
import Category3 from "../../assets/Home/categories/Category3.png";
import Category4 from "../../assets/Home/categories/Category4.png";
import Category5 from "../../assets/Home/categories/Category5.png";
import Category6 from "../../assets/Home/categories/Category6.png";
import Category7 from "../../assets/Home/categories/Category7.png";
import Category8 from "../../assets/Home/categories/Category8.png";
import Category9 from "../../assets/Home/categories/Category9.png";
import Category12 from "../../assets/Home/categories/Category12.png";
import Category10 from "../../assets/Home/categories/Category10.png";
import Category11 from "../../assets/Home/categories/Category11.png";
import MoreCategory from "../../assets/Home/categories/MoreCategory.svg";
import home_img from "../../assets/Home/home_img.png";
import about_us_img from "../../assets/Home/About Us.svg";
import jago_grahak_jago from "../../assets/Home/jago_grahak_jago.png";
import categories_svg from "../../assets/Home/Categories.svg";
import startup from "../../assets/Home/startup.png";
import maintenance_svg from "../../assets/Home/Maintenance.svg";
import Service1 from "../../assets/Home/categories/Service1.png";
import Service2 from "../../assets/Home/categories/Service2.png";
import Service3 from "../../assets/Home/categories/Service3.png";
import Service4 from "../../assets/Home/categories/Service4.png";
import Service5 from "../../assets/Home/categories/Service5.png";
import Service6 from "../../assets/Home/categories/Service6.png";
import Service7 from "../../assets/Home/categories/Service7.png";
import "../../index.css";
import AppStoreModal from "../utils/AppStoreModal";

const Home = () => {
  const contentRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [appStoreModal, setAppStoreModal] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const scroller = useMemo(() => [
    { id: 1, link: scroller1 },
    { id: 2, link: scroller2 },
    { id: 3, link: scroller3 },
    { id: 4, link: scroller4 },
    { id: 5, link: scroller5 },
  ], []);


  const categories = useMemo(() => [
    { id: 1, link: Category1 },
    { id: 2, link: Category12 },
    { id: 3, link: Category2 },
    { id: 4, link: Category3 },
    { id: 5, link: Category4 },
    { id: 6, link: Category5 },
    { id: 7, link: Category6 },
    { id: 8, link: Category7 },
    { id: 9, link: Category8 },
    { id: 10, link: Category9 },
    { id: 11, link: Category10 },
    { id: 12, link: Category11 },
  ], []);

  const services = useMemo(() => [
    { id: 1, link: Service1 },
    { id: 2, link: Service2 },
    { id: 3, link: Service3 },
    { id: 4, link: Service4 },
    { id: 5, link: Service5 },
    { id: 6, link: Service6 },
    { id: 7, link: Service7 },
    { id: 0, link: MoreCategory },
  ], []);

  const calculateActiveIndex = useCallback(() => {
    const contentElement = contentRef.current ?? 0;
    if (!contentElement) return;
    const scrollLeft = contentElement.scrollLeft;
    const containerWidth = 260;
    const totalWidth = contentElement.scrollWidth;
    let newIndex;

    if (scrollLeft === 0) {
      newIndex = 0;
    } else if (scrollLeft + containerWidth >= totalWidth) {
      newIndex = 0;
    } else {
      newIndex = Math.floor(scrollLeft / containerWidth);
    }
    setActiveIndex(prevIndex => prevIndex !== newIndex ? newIndex : prevIndex);
  }, []);
  // Attach scroll event listener


  useEffect(() => {
  let scrollInterval;
    
  const handleScroll = calculateActiveIndex;
  const contentElement = contentRef.current;
  if (contentElement) {
    contentElement.addEventListener("scroll", handleScroll, { passive: true });
  }

  scrollInterval = setInterval(() => {
    if (isPaused || !contentElement) return;

    const containerWidth = contentElement.offsetWidth;
    const totalWidth = contentElement.scrollWidth;

    if (contentElement.scrollLeft + containerWidth >= totalWidth) {
      contentElement.scrollTo({ left: 0, behavior: "auto" });
    } else {
      contentElement.scrollTo({
        left: contentElement.scrollLeft + 1,
        behavior: "auto",
      });
    }
  }, 20);

  return () => {
    if (scrollInterval) clearInterval(scrollInterval);
    if (contentElement) {
      contentElement.removeEventListener("scroll", handleScroll);
    }
  };
}, [isPaused, calculateActiveIndex]);


  const handleMouseEnter = useCallback(() => setIsPaused(true), []);
  const handleMouseLeave = useCallback(() => setIsPaused(false), []);

  return (
    <div className="w-screen h-max pt-[65px] md:pt-[35px]">
      <a
        href="https://play.google.com/store/apps/details?id=com.culturtapgenie.Genie"
        className="cursor-pointer mt-[20px] md:mt-[40px] lg:mt-[60px] block"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={home_img}
          alt="Download on Play Store"
          loading="eager"
          className="w-screen h-auto object-cover"
        />
      </a>

{/*  About Us Text */}
      <div className="w-full flex flex-col md:mt-10 px-4">
        <div className="flex flex-col w-full pl-[20px] pr-[10px] sm:pl-[50px] lg:px-[120px] my-10 gap-[20px]">
          <img
            src={about_us_img}
            alt="About Us"
            className="w-[250px] h-auto object-contain mb-4 mx-auto"
          />
          <div className="text-center max-w-[900px] mx-auto">
            <h2 className="text-[20px] md:text-[24px] font-bold text-[#001B33] mb-4 leading-snug ">
              Discover the Unmatched Price Deal - Start Bargaining on Fashion,
              Home, Appliance, Service & more.
            </h2>

            <p className="text-[15px] md:text-[16px] poppins-regular text-[#001B33] mb-4 leading-relaxed">
              Start Your Local Market Search & Bargaining!
              <br />
              Spades My Master!
            </p>


            <p className="text-[15px] md:text-[16px] poppins-regular text-[#001B33] mb-4 leading-relaxed">
              Enjoy Unlimited Free Bargaining. Discover All Your Product and Maintenance Service Needs in the Local Market. Discover Great Shopping Deals in Categories Such as Fashion, Sari, Suit, Shoe, Bag, Electronics, Gifts, Jewel, Appliances, Watches, Sports, Utensils, Plumber, Electrician, and More. Genie Grants Every Wish of My Master!
            </p>


            {showMore && (
              <div className="text-[15px] md:text-[16px] poppins-regular text-[#001B33] leading-relaxed whitespace-pre-line text-center">
                Your Wish Is Just a Tap Away.
                {"\n"}Order Genie
                {"\n"}Select Vendors.
                {"\n\n"}💥 Just Boom!
                {"\n\n"}Receive Unlimited Options and Offers, Start Bargaining with Vendors, and Discover the Unmatched Price Deal. Enjoy Unlimited Free Bargaining with Multiple Vendors to Find the "True Lowest Price Deal" for You.
                {"\n\n"}The Game of Bargaining! Your Local Market Journey Begins Here.
                {"\n\n"}Are You Traveling to a New Place? Check Out the Best-Rated Local Stores for Your Immediate Needs. Genie Helps You Connect with the Right Vendor.
                {"\n"}Save Your Time & Money with Us.
                {"\n"}Happy Traveling! Genie is Always with You.
                {"\n\n"}📍 Our Presence:
                {"\n"}Bengaluru / Jhansi
                {"\n\n"}Expressing True Love for Indian Shopping Culture!
                {"\n"}❤️ INDIA ❤️
              </div>
            )}

            {/* Toggle button as image */}
            <div className="mt-4">
              <img
                src={showMore ? viewLessImg : viewMoreImg}
                alt={showMore ? "View Less" : "View More"}
                className="w-[120px] cursor-pointer mx-auto"
                onClick={() => setShowMore((prev) => !prev)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-16 my-6">
      <img
        src={Banner}
        alt="App Screenshots"
        className="w-full h-auto object-cover my-6"
      />
      </div>



      {/* SCROLLER */}
      <div className="pl-[10px] mr-[10px] mx-auto sm:pl-[20px] sm:pr-[20px] lg:pl-[40px] ">
        <div
          className="flex  gap-[15px] pl-[30px]  overflow-x-scroll scrollbar-hidden bg-white"
          ref={contentRef}
        >
          {scroller.map((item, index) => (
            <div
              key={item.id} 
              className={`card-slider md:mt-[60px] w-[320px] h-[300px] md:w-[360px] md:h-[360px] lg:w-[360px] lg:h-[360px]  flex-shrink-0  m-2 mb-10 sha ${
                activeIndex === index ? "active" : ""
              }`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className="w-full h-full flex justify-center ">
                <img
                  src={item.link}
                  alt="culturtap-works"
                  loading="lazy"
                  className="w-full h-full"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bullet-points pl-[20px]  sm:pl-[50px]  lg:pl-[120px]">
        {scroller.map((item, index) => (
          <div
            key={item.id}
            className={`bullet-point ${
              index === activeIndex
                ? "active-bullet transition-all duration-500"
                : ""
            }`}
            onClick={() => {
              const contentElement = contentRef.current;
              const containerWidth = `450px`;
              contentElement.scrollTo({
                left: index * containerWidth,
                behavior: "smooth",
              });
            }}
          ></div>
        ))}
      </div>

      {/* Categories */}
      <div className="w-full flex flex-col md:flex-row ">
        <div className="w-screen flex flex-1 flex-col  flex-wrap gap-[30px] lg:gap-[40px] my-10 max-lg:justify-center">
          <img
            src={categories_svg}
            alt="Categories"
            className="w-[250px] h-auto object-contain mx-auto"
          />
          <div className="flex flex-row flex-wrap gap-[15px] max-w-[1000px] mx-auto justify-center max-sm:gap-[10px]">
            {categories.map((item, index) => (
              <div key={item.id}>
                <div className="max-sm:w-[155px] max-md:w-[160px] w-full h-full flex max-md:justify-center">
                  <img
                    src={item.link}
                    alt="culturtap-categories"
                    loading="lazy"
                    className="w-full h-full"
                  />
                </div>
              </div>
            ))}
          </div>
          <br />
          <img
            src={maintenance_svg}
            alt="Categories"
            className="w-[250px] h-auto object-contain mx-auto"
          />
          <div className="flex flex-row flex-wrap gap-[15px] max-w-[1000px] mx-auto justify-center max-sm:gap-[10px]">
            {services.map((item, index) => (
              <div key={item.id}>
                <div className="max-sm:w-[155px] max-md:w-[160px] w-full h-full flex max-md:justify-center ">
                  <img
                    src={item.link}
                    alt="culturtap-services"
                    loading="lazy"
                    className="w-full h-full"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>


      {/* Jago Grahak Jago */}
      <img
        src={jago_grahak_jago}
        alt="jago_grahak_jago"
        className="w-full h-auto object-cover"
      />
      <br />
      <br />
      <br />
      <img
        src={startup}
        alt="Startup"
        className="w-full max-w-[1000px] mx-auto h-auto object-contain"
      />

      {appStoreModal && <AppStoreModal setAppStoreModal={setAppStoreModal} />}
    </div>
  );
};

export default Home;
